import { HttpClient, HttpEvent } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  YearlyCalibrationCertificate,
  YearlyCalibrationCertificateRequest,
} from './yearly-calibration-certificates.models';

@Injectable({ providedIn: 'root' })
export class YearlyCalibrationCertificatesService {
  private readonly baseUrl = `${environment.apiUrl}/lab-equipment/yearly-calibration-certificates`;
  private readonly http = inject(HttpClient);

  getCertificates(): Observable<YearlyCalibrationCertificate[]> {
    return this.http.get<YearlyCalibrationCertificate[]>(this.baseUrl);
  }

  getCertificate(id: number): Observable<YearlyCalibrationCertificate> {
    return this.http.get<YearlyCalibrationCertificate>(`${this.baseUrl}/${id}`);
  }

  createCertificate(
    request: YearlyCalibrationCertificateRequest,
    file: File,
  ): Observable<HttpEvent<YearlyCalibrationCertificate>> {
    return this.http.post<YearlyCalibrationCertificate>(
      this.baseUrl,
      this.toFormData(request, file),
      { observe: 'events', reportProgress: true },
    );
  }

  updateCertificate(
    id: number,
    request: YearlyCalibrationCertificateRequest,
    file?: File,
  ): Observable<HttpEvent<YearlyCalibrationCertificate>> {
    return this.http.put<YearlyCalibrationCertificate>(
      `${this.baseUrl}/${id}`,
      this.toFormData(request, file),
      { observe: 'events', reportProgress: true },
    );
  }

  downloadAttachment(id: number): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}/download`, { responseType: 'blob' });
  }

  deleteCertificate(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  private toFormData(request: YearlyCalibrationCertificateRequest, file?: File): FormData {
    const form = new FormData();
    form.append('date', request.date);
    form.append('name', request.name);
    form.append('description', request.description);
    if (request.note) form.append('note', request.note);
    if (file) form.append('file', file);
    return form;
  }
}
